import { render, staticRenderFns } from "./Vinculado.vue?vue&type=template&id=64442234&"
import script from "./Vinculado.vue?vue&type=script&lang=js&"
export * from "./Vinculado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports